(() => {
  const DATA_SELECTOR = '#uf-product-discount-data';
  const BADGE_CLASS = 'uf-product-gallery-discount';
  const HOST_CLASS = 'uf-product-gallery-badge-host';
  const GALLERY_SELECTORS = [
    '.cpd__main-image-container',
    '[class*="pdp__stage-"]',
    '.product-media__slider'
  ];

  function readProductData() {
    const dataElement = document.querySelector(DATA_SELECTOR);
    if (!dataElement) return null;

    try {
      return JSON.parse(dataElement.textContent);
    } catch (error) {
      console.error('Unable to read product discount data.', error);
      return null;
    }
  }

  function findGalleryHost() {
    for (const selector of GALLERY_SELECTORS) {
      const host = document.querySelector(selector);
      if (host) return host;
    }
    return null;
  }

  function getSelectedVariantId(productData) {
    const urlVariantId = new URL(window.location.href).searchParams.get('variant');
    if (urlVariantId && productData.variants.some(variant => String(variant.id) === urlVariantId)) {
      return urlVariantId;
    }

    const formVariantIds = Array.from(document.querySelectorAll('input[name="id"]'))
      .map(input => input.value)
      .filter(Boolean);
    const matchingFormId = formVariantIds.find(id => (
      productData.variants.some(variant => String(variant.id) === String(id))
    ));

    return matchingFormId || String(productData.initialVariantId || '');
  }

  function calculateDiscount(variant) {
    const price = Number(variant?.price) || 0;
    const compareAtPrice = Number(variant?.compareAtPrice) || 0;
    if (!price || compareAtPrice <= price) return 0;
    return Math.floor(((compareAtPrice - price) * 100) / compareAtPrice);
  }

  function ensureBadge(host) {
    let badge = host.querySelector(`:scope > .${BADGE_CLASS}`);
    if (badge) return badge;

    badge = document.createElement('span');
    badge.className = BADGE_CLASS;
    badge.setAttribute('aria-label', 'Product discount');
    host.classList.add(HOST_CLASS);
    host.appendChild(badge);
    return badge;
  }

  function updateDiscountBadge() {
    const productData = readProductData();
    const host = findGalleryHost();
    if (!productData || !host) return;

    const variantId = getSelectedVariantId(productData);
    const variant = productData.variants.find(item => String(item.id) === String(variantId));
    const discount = calculateDiscount(variant);
    const badge = ensureBadge(host);

    badge.hidden = discount < 1;
    badge.textContent = discount > 0 ? `-${discount}%` : '';
  }

  function queueBadgeUpdate() {
    window.setTimeout(updateDiscountBadge, 0);
    window.setTimeout(updateDiscountBadge, 80);
  }

  function init() {
    updateDiscountBadge();
    document.addEventListener('change', queueBadgeUpdate);
    document.addEventListener('click', event => {
      if (event.target.closest('button, label, input, select')) queueBadgeUpdate();
    });
    document.addEventListener('shopify:section:load', queueBadgeUpdate);
    window.addEventListener('popstate', queueBadgeUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
